import axios from '../utils/http';

const BASE_URL = '/api/game';

// 获取所有gameTypeName信息
export const fetchAllGameTypeNames = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/type/all`);
    return response.data;
  } catch (error) {
    console.error('获取所有游戏类型失败:', error);
    throw error;
  }
};

// 根据matchID获取所有gameTypeName信息
export const fetchAllGameTypeNamesByMatchID = async (matchID) => {
  try {
    const response = await axios.get(`${BASE_URL}/type/${matchID}`);
    return response.data;
  } catch (error) {
    console.error('获取所有游戏类型失败:', error);
    throw error;
  }
};

// 根据scheduleID获取game信息
export const fetchGameInfoByScheduleID = async (scheduleID) => {
  try {
    const response = await axios.get(`${BASE_URL}/schedule/${scheduleID}`);
    return response.data;
  } catch (error) {
    console.error('获取比赛信息失败:', error);
    throw error;
  }
};

// 根据matchID获取game信息
export const fetchGameInfoByMatchID = async (matchID) => {
  try {
    // 比赛详情页使用：携带 active=1，后端按激活场次过滤对应的 Games
    const response = await axios.get(`${BASE_URL}/match/${matchID}`, {
      params: {
        active: 1,
      },
    });
    return response.data;
  } catch (error) {
    console.error('获取比赛信息失败:', error);
    throw error;
  }
};

// 根据gameID获取game信息
export const fetchGameInfoByGameID = async (gameID) => {
  try {
    const response = await axios.get(`${BASE_URL}/${gameID}`);
    return response.data;
  } catch (error) {
    console.error('获取比赛信息失败:', error);
    throw error;
  }
};

// 根据gameID只取Games表的数据
export const onlyFetchGameDataByGameID = async (gameID) => {
  try {
    const response = await axios.get(`${BASE_URL}/${gameID}/onlyGameData`);
    return response.data;
  } catch (error) {
    console.error('获取比赛数据失败:', error);
    throw error;
  }
};

// 保存数据gameData
export const saveScoreData = async (scoreData) => {
  try {
    const response = await axios.post(`${BASE_URL}/savescore`, scoreData);
    return response.data;
  } catch (error) {
    console.error('保存比赛数据失败:', error);
    throw error;
  }
};


// 新增：保存发/挑边及初始站位
export const saveServeSideData = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/saveServeSide`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('保存发/挑边数据失败:', error);
    throw error;
  }
};


// 交换场区
export const switchSide = async (gameID) => {
  try {
    const response = await axios.put(`${BASE_URL}/switchSide`, { gameID });
    return response.data;
  } catch (error) {
    console.error('交换场区失败:', error);
    throw error;
  }
};

// 更新gameID的gameStatus
export const updateGameStatus = async (gameData) => {
  try {
    const response = await axios.put(`${BASE_URL}/updateStatus`, gameData);
    return response.data;
  } catch (error) {
    console.error('更新比赛状态失败:', error);
    throw error;
  }
}

// 根据gameID回退比赛得分
export const rollbackGameScore = async (gameID) => {
  try {
    const response = await axios.put(`${BASE_URL}/rollback`, gameID);
    return response.data;
  } catch (error) {
    console.error('回退比赛得分失败:', error);
    throw error;
  }
}

// 记录弃权方并结束比赛
export const finishGameByGiveUp = async (payload) => {
  try {
    console.log('正在提交比赛终止信息:', payload);
    const response = await axios.post(`${BASE_URL}/finishByGiveUp`, payload);
    return response.data;            // { message: 'xxx' }
  } catch (error) {
    console.error('回退比分失败:', error);
    throw error;
  }
};

// 更新比赛用球数：delta = +1 或 -1
export const updateGameBirdies = async (gameID, delta) => {
  try {
    const res = await axios.patch(`${BASE_URL}/${gameID}/birdies`, { delta });
    return res.data;       // { success:true, birdies: newCount }
  } catch (err) {
    console.error('更新用球失败:', err);
    throw err;
  }
};

// 一次性清空所有比分
export const clearGameScore = async (gameID) => {
  try {
    const response = await axios.put(`${BASE_URL}/clearScore`, { gameID });
    return response.data;       // { success: true, message: '比分已清空' }
  } catch (error) {
    console.error('清空比赛比分失败:', error);
    throw error;
  }
};

// 清空事件并重置弃权标记（仅更新 give_up_side = 0，不影响其它字段）
export const clearGameIncidents = async (gameID) => {
  try {
    const res = await axios.put(`${BASE_URL}/clearIncidents`, { gameID });
    return res.data;   // { success:true, message:'事件已清空，弃权标记已重置' }
  } catch (err) {
    console.error('清空事件失败:', err);
    throw err;
  }
};


/**
 * 一次性设置用球数量
 */
export async function setGameBirdies(gameID, birdies) {
  try {
    console.log('正在设置用球数:', { gameID, birdies });
    const res = await axios.put(
      `${BASE_URL}/${gameID}/birdies`,
      { birdies }
    );
    return res.data;
  } catch (err) {
    console.error('【setGameBirdies】一次性设置用球数失败:', err);
    throw err;
  }
}


// 拉取“我”已下载的映射（仅当前用户维度）
export const fetchScoreSheetDownloadedMap = async (matchID) => {
  const { data } = await axios.get(`${BASE_URL}/score-sheet/downloaded-map`, { params: { matchID }});
  return data?.map || {};
};

// 兜底标记：我已下载
export const markScoreSheetDownloaded = async (gameID) => {
  const { data } = await axios.post(`${BASE_URL}/score-sheet/mark-downloaded`, { gameID });
  return data;
};


/**
 * 确认/调整三人队的自由人（把自由人移到数组最后，确保前两人参与站位/发接发）
 * @param {Object} param0
 * @param {number} param0.gameID
 * @param {number|null} param0.libero1Index  队1自由人索引（0-based）；传 null 表示不改
 * @param {number|null} param0.libero2Index  队2自由人索引（0-based）；传 null 表示不改
 */
export const confirmFreePlayer = async ({ gameID, libero1Index = null, libero2Index = null }) => {
  const resp = await axios.post(`${BASE_URL}/confirmFreePlayer`, {
    gameID,
    libero1Index,
    libero2Index,
  });
  return resp.data;
};